import { render } from "./patientImaging.vue?vue&type=template&id=06ac52c9&scoped=true"
import script from "./patientImaging.vue?vue&type=script&lang=js"
export * from "./patientImaging.vue?vue&type=script&lang=js"

import "./patientImaging.vue?vue&type=style&index=0&id=06ac52c9&lang=scss&scoped=scoped"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06ac52c9"]])

export default __exports__